import Snackbar from '@mui/material/Snackbar'
import Box from '@mui/material/Box'
import UpdateFail from '../1elements/Icons/svg/UpdateFail.svg'
import {reExportedColors} from '../1elements'
import CloseIconButton from '../1elements/Buttons/IconButtons/CloseIconButton'

const messageSx = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    '& img': {
        marginRight: '15px',
        width: '22px'
    },
    '& p': {
        margin: 0
    }
}

const FormErrorSnackbar = ({isSnackbarOpen, setIsSnackbarOpen, content}) => {
    const messageContent = () => {
        return(
            <Box sx={messageSx}>
                <img alt="Fail" src={UpdateFail} />
                <p>{content ? content : 'There are some errors in your inputs' }</p>
            </Box>
        )
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setIsSnackbarOpen(false);
    }

    return(
        <Snackbar action={<CloseIconButton onClick={handleClose} />} anchorOrigin={{vertical: 'bottom', horizontal: 'center',}}
                  onClose={handleClose} open={isSnackbarOpen} autoHideDuration={5000} message={messageContent()}
                  sx={{ '& .MuiSnackbarContent-root': { backgroundColor: reExportedColors.RED } }} />
    )
}

export default FormErrorSnackbar
